import { apiClient as api } from "./httpClient";

// Construtor de ferramentas de IA (Opção 3). Só o Administrador gerencia (o backend valida via
// [HasPermission("ai-agents")] + EntityOwnershipGuard). As definições ficam no tenant.

// Fonte segura do registro em código (para o wizard). Já vem sem campos clínico-sensíveis.
export interface AiToolSourceField {
  key: string;
  label: string;
  sensitivity: string; // administrativo | identificacao
  anonymizable: boolean; // nome de pessoa: aceita o toggle de anonimização
}
export interface AiToolSourceFilter {
  fieldKey: string;
  operators: string[]; // equals | not_equals | contains | greater_than | less_than
}
export interface AiToolSourceParam {
  key: string;
  type: string;
  description: string;
}
export interface AiToolSource {
  key: string;
  label: string;
  fields: AiToolSourceField[];
  filters: AiToolSourceFilter[];
  params: AiToolSourceParam[];
}

// Filtro fixo de uma definição.
export interface AiToolFilter {
  fieldKey: string;
  operator: string;
  value: string | null;
}

// Campo de uma definição: chave + se anonimiza o nome (só vale em campo anonimizável).
export interface AiToolField {
  fieldKey: string;
  anonymize: boolean;
}

// Campo como retornado pelo GET de definições (key/anonymize).
export interface AiToolDefinitionField {
  key: string;
  anonymize: boolean;
}

export interface AiToolDefinition {
  id: string;
  key: string;
  label: string;
  description: string;
  sourceKey: string;
  sourceLabel: string;
  requiredFunctionality: string;
  sensitivity: string;
  active: boolean;
  fields: AiToolDefinitionField[];
  filters: AiToolFilter[];
}

// Payload de criação (chave e fonte são imutáveis depois).
export interface AiToolCreateInput {
  key: string;
  label: string;
  description: string;
  sourceKey: string;
  fields: AiToolField[];
  filters: AiToolFilter[];
}

// Payload de edição (só rótulo/descrição/campos/filtros).
export interface AiToolUpdateInput {
  label: string;
  description: string;
  fields: AiToolField[];
  filters: AiToolFilter[];
}

export const aiToolsService = {
  getSources: async (): Promise<AiToolSource[]> => {
    const response = await api.get("/ai-tools/sources");
    return response.data;
  },

  getDefinitions: async (entityId: string): Promise<AiToolDefinition[]> => {
    const response = await api.get(`/ai-tools/by-entity/${entityId}`);
    return response.data;
  },

  create: async (entityId: string, input: AiToolCreateInput): Promise<string> => {
    const response = await api.post("/ai-tools", { entityId, ...input });
    return response.data.id as string;
  },

  update: async (id: string, input: AiToolUpdateInput): Promise<void> => {
    await api.put(`/ai-tools/${id}`, input);
  },

  remove: async (id: string): Promise<void> => {
    await api.delete(`/ai-tools/${id}`);
  },
};

// Rótulos amigáveis dos operadores (para o wizard).
export const OPERATOR_LABELS: Record<string, string> = {
  equals: "igual a",
  not_equals: "diferente de",
  contains: "contém",
  greater_than: "maior que",
  less_than: "menor que",
};
